



















































































import { Component } from "vue-property-decorator";
import WidgetBase from "../WidgetBase";
import { getCookie } from "@szgc/plt-core-v2";

import protocolCheck from "./proto";
import { useSocket, uid, socket, setStorage, getStorage } from "@szgc/plt-core-v2";

// import "@szgc/plt-core-v2/dist/main.css";
import Pdf from "./Pdf/index.vue";

@Component({
  name: "WordWidget",
  components: { Pdf }
})
export default class WordWidget extends WidgetBase {
  private visible: boolean = false;

  private opId: string = uid();

  public isEditing: boolean = false;

  private message: string = "正在准备下载文档";

  private isTipShow: boolean = false;

  view() {
    this.visible = true;
  }

  dwInstaller() {
    const a = document.createElement("a") as HTMLAnchorElement;
    a.href = "/api/appproc/file-word/installer";
    a.download = "install-setup.exe";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  exec(): Promise<boolean> {
    return new Promise((resolve) => {
      protocolCheck(
        this.clientUrl,
        () => {
          resolve(false);
        },
        () => {
          resolve(true);
        }
      );
    });
  }

  open() {
    if (this.isEditing) return;

    const iframe = document.createElement("iframe");
    iframe.src = this.clientUrl;
    iframe.style.display = "none";
    document.body.appendChild(iframe);
    setTimeout(() => {
      document.body.removeChild(iframe);
    }, 300);
  }

  get clientUrl() {
    const { port, protocol, hostname } = location;

    const config = JSON.parse(sessionStorage.getItem("PLT_CONFIG") || "{}");
    const params = {
      schema: protocol.replace(":", ""),
      ip: hostname,
      port: port,
      jwtKey: config.jwtKey,
      token: getCookie(config.jwtKey),
      pacId: this.widget.pac.pacId, //
      businessId: this.widget.pac.businessId, //
      reqToken: this.widget.pac.reqToken, //
      propertyNamePath: this.widget.path,
      pdf: this.widget.ext?.pdf?.attId || "",
      opId: this.opId
    };
    console.log(params);
    return "szgcdocs://" + encodeURIComponent(JSON.stringify(params));
  }

  get presentButton() {
    return {
      color: this.widget.color,
      backgroundColor: this.widget.backgroundColor
    };
  }

  get presentText() {
    return {
      color: this.widget.color,
      textDecoration: this.widget.underLine === "1" ? "underline" : "none"
    };
  }

  created() {
    useSocket();
  }

  doNotTip() {
    setStorage("is_doc_client_installed", "1");
    this.isTipShow = false;
  }

  mounted() {
    const isClientInstalled = getStorage("is_doc_client_installed");
    if (isClientInstalled === "1") {
      this.isTipShow = false;
    } else {
      this.isTipShow = true;
    }

    socket.on("doc_client_event", (message: string) => {
      const res = JSON.parse(message) as {
        event: "download" | "edit" | "close";
        opId: string;
        data: any;
      };

      setStorage("is_doc_client_installed", "1");

      console.log(res);
      if (res.opId !== this.opId) {
        console.log("操作id不匹配，忽略");
        return;
      }
      this.isEditing = true;
      if (res.event === "download") {
        this.message = "文档下载中" + res.data + "%";
      } else if (res.event === "edit") {
        this.message = "文档编辑中";
      } else if (res.event === "close") {
        this.message = "文档上传中";
        setTimeout(() => {
          this.isEditing = false;
          this.message = "文档上传成功";
        }, 300);
      }
    });
  }

  destroyed() {
    socket.off("doc_client_event");
  }
}
